export const TEMPLATE_ID = "library-template-2"